export default [{
  path: '/portal-clientes/portal-documentos',
  name: 'portaldocumentos-externo',
  component: () => import('@/app-modulo/documento/portal-documentos-externo/PortalDocumentosExterno.vue'),
  meta: {
    requiredAuth: true,
    resource: 'portaldocumentosexterno',
    action: 'read',
    navActiveLink: 'portaldocumentos-externo',
    pageTitle: 'Portal de Documentos',
  },
}]
